import {
  PlateElement,
  PlateElementProps,
} from 'lib-knowledge-document-structure/plate/common';
import {
  MyInterlinkElement,
  MyValue,
} from 'lib-knowledge-document-structure/plateTypes';
import { forwardRef } from 'react';

import s from './elements.module.scss';

const InterlinkElement = forwardRef<
  React.ElementRef<typeof PlateElement>,
  PlateElementProps<MyValue, MyInterlinkElement>
>(({ className, children, ...props }, ref) => {
  return (
    <PlateElement asChild ref={ref} className={className} {...props}>
      <a className={s.interlink}>{children}</a>
    </PlateElement>
  );
});

InterlinkElement.displayName = 'InterlinkElement';
export { InterlinkElement };
